import settings from '../../config/settings';
import axiosNonAuth from './axiosNonAuth';

const {apiBaseUrl} = settings;

export default class SubscriptionApi {
  static requestSubscription(phone, cardId) {
    return axiosNonAuth.post(`${apiBaseUrl}/subscriptions/`, {card: cardId, phone});
  }
}
